export default {"src":"/_next/static/media/icon-thumb-down.35c9d2b2.svg","height":300,"width":300,"blurWidth":0,"blurHeight":0};